import { render, staticRenderFns } from "./ImportCourse.vue?vue&type=template&id=47268854&scoped=true"
import script from "./ImportCourse.vue?vue&type=script&lang=js"
export * from "./ImportCourse.vue?vue&type=script&lang=js"
import style0 from "./ImportCourse.vue?vue&type=style&index=0&id=47268854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47268854",
  null
  
)

export default component.exports